<template>
    <ValidationObserver ref="form">
        <div class="row">
            <div class="col-sm-12">
                <label for="" class="form-label">Full Name: *</label>
                <div class="row">
                    <ValidationProvider class="col-6 mb-3" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <input
                                type="text"
                                id="first_name"
                                placeholder="First Name"
                                :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                v-model="form.first_name"
                            >
                        </div>

                        <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-6 mb-3" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <input
                                type="text"
                                id="last_name"
                                placeholder="Last Name"
                                :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                v-model="form.last_name"
                            >
                        </div>

                        <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
            </div>

            <ValidationProvider class="col-sm-12 mb-3" name="Email" rules="required|email" v-slot="{ errors }">
                <label for="email" class="form-label">Email Address: *</label>
                <div class="form-group mb-0">
                    <input id="email" type="text" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="form.email">
                </div>

                <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                    {{ errors[0] }}
                </div>
            </ValidationProvider>

            <ValidationProvider class="col-sm-12 mb-3" name="Phone" rules="required|us_phone_number" v-slot="{ errors }">
                <label for="phone" class="form-label">Phone Number: *</label>
                <div class="form-group mb-0">
                    <input
                        type="text"
                        id="phone"
                        :class="['form-control mb-1', {'input-error' : errors[0] }]"
                        v-mask="'+1(###)-###-####'"
                        v-model="form.phone"
                    >
                </div>

                <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                    {{ errors[0] }}
                </div>
            </ValidationProvider>

            <div class="col-sm-12">
                <label for="" class="form-label">Interested in:</label>
                <div class="form-group">
                    <input type="text" name="interested" class="form-control" >
                </div>
            </div>

            <div class="col-12">
                <label for="" class="form-label">Questions/Comments:</label>
                <div class="form-group">
                    <textarea class="form-control" name="comments"></textarea>
                </div>
            </div>
            <ValidationProvider class="col-sm-8" name="Captcha" rules="required" v-slot="{ errors }">
                <div class="form-group recaptcha mb-0">
                    <vue-recaptcha
                        class="g-recaptcha"
                        ref="googleRecaptcha"
                        @verify="verifyCaptcha"
                        :sitekey="captcha_key"
                        v-model="form['g-recaptcha-response']"
                    ></vue-recaptcha>
                </div>

                <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                    {{ errors[0] }}
                </div>
            </ValidationProvider>
            <div class="col-sm-4 text-right">
                <div class="form-group">
                    <button type="submit" class="btn" @click="validate">
                        <span>Submit</span>
                    </button>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    import resetAnimation from "../../../../../../resources/js/mixins/reset-animation";
    import swalMessages from "../../../../../../resources/js/mixins/swal-messages";

    export default {
        name: "ContactForm",
        components: { VueRecaptcha },
        mixins:  [ resetAnimation, swalMessages ],
        props: {
            captcha_key: String
        },
        data() {
            return {
                form: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    phone: null,
                    address: null,
                    interest: null,
                    comment: null,
                    'g-recaptcha-response': null,
                }
            }
        },
        methods: {
            verifyCaptcha(key) {
                this.form['g-recaptcha-response'] = key;
            },
            validate() {
                (async () => {
                    const form = this.$refs.form;
                    const valid = await form.validate()
                    const errors = [];

                    const setErrors = () => {
                        for (const errorsKey in form.errors) {
                            if (form.errors.hasOwnProperty(errorsKey)) {
                                if (form.errors[errorsKey].length) {
                                    errors.push(errorsKey);
                                }
                            }
                        }
                    }

                    if (valid) {
                        this.submit(this.form)
                    } else {

                        setErrors();

                        this.showValidationErrorMessage(errors);
                        this.resetAnimation();
                    }
                })();
            },
            resetForm() {
                for (const key in this.form) {
                    if (this.form.hasOwnProperty(key)) {
                        this.form[key] = null;
                    }
                }
            },
            submit(form) {
                this.showLoadingMessage();

                axios.post('contact', form).then(response => {
                    if (response.status === 200) {
                        this.$refs.form.reset();
                        this.$refs.googleRecaptcha.reset();
                        this.resetForm();

                        this.$swal.close();

                        setTimeout(() => {
                            this.showSuccessMessage('Your form has been successfully submitted!')
                        }, 800)
                    }

                }).catch(error => {
                    console.log(error)
                })
            }
        },
    }
</script>

<style scoped>
    .input-error {
        border: 2px solid #ffb996 !important;
        background-color: #fff8f6 !important;
        border-radius: 3px !important;
    }

    .label-error {
        color: #d54141 !important;
    }

    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }
</style>
